/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

function SteveRubensteinPage(props) {
  const title = 'Steve Rubenstein';
  const content = 'Executive General Manager, Money Division';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Steve Rubenstein'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/steve-rubenstein-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Steve joined Latitude in August 2024 as Executive General Manager of
            Latitude Money, the company’s personal and motor loans businesses.
            <br />
            <br />
            Before Latitude, Steve was Managing Director Consumer Finance at
            Westpac Group where he was the end-to-end business owner for credit
            cards, personal loans, and emerging payments.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Steve brings over 25 years of global experience with roles at the
            Royal Bank of Scotland Group in the UK, and ANZ Banking Group in
            Australia. Steve began his career with First Manhattan Consulting
            Group out of New York.
            <br />
            <br />
            He holds a Bachelor of Science in Economics from the Wharton School
            of the University of Pennsylvania with concentrations in Finance and
            Decision Science. Steve also qualified as a CFA Charterholder in
            2004.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
}

export default SteveRubensteinPage;
